"use strict";

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ModalContents = require("./ModalContents.js");

var _ModalContents2 = _interopRequireDefault(_ModalContents);

var _Portal = require("../Portal/Portal.js");

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper for the Modal, to put it inside of a Portal.
 * The Modal needs its own lifecycle and therefore this wrapper is necessary
 */

var Modal = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _Portal2.default,
        null,
        _react2.default.createElement(_ModalContents2.default, this.props)
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

module.exports = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/Modal/Modal.js
// module id = 1279
// module chunks = 2